import Axios from 'axios'
const Api = Axios.create({
	baseURL: process.env.NODE_ENV === 'production' ? '/' : '/api',
	// 'https://podium.chanel.com.cn/',
	// https://uat.ripple-corp.com/
	headers: {
		'Content-Type': 'application/json; charset=utf-8',
		'Access-Control-Allow-Origin': '*',
	},
})
// const errTip = {
//   '0': '参数错误',
//   '1000': '未知错误',
//   '1001': '系统错误',
//   '1002': '参数不可为空',
//   '1003': '参数数据类型不匹配',
//   '1004': '记录不存在',
//   '1005': '验证码错误',
//   '2000': '用户已注册',
//   '2001': '活动已结束',
//   '2002': '活动预约已满',
//   '2003': '该时间预约已满',
//   '3000': '用户未登录',
//   '40001': '接口调用失败',
//   '5000': '权限不足'
// }
// Add a request interceptor
Api.interceptors.request.use(
	function(config) {
		// Do something before request is sent
		return config
	},
	function(error) {
		// Do something with request error
		return Promise.reject(error)
	}
)

// Add a response interceptor
Api.interceptors.response.use(
	function(response) {
		// Do something with response data
		if (response.data.code === '00000') {
			return response.data
		} else {
			// alert(errTip[response.data.code])
		}
		return response
		// return response;
	},
	function(error) {
		// Do something with response error
		console.log(error)
		return Promise.reject(error)
	}
)
/**
 * 接口
 */
const pre = 'holiday-podium-surface/booking/'
const impower = 'opening-party-server-api/'
const interfaces = {
	get_scene: pre + 'scene', //获取场次信息
	find_all: pre + 'capacity', //查询所有渠道
	is_exist: pre + 'check', //检查用户是否存在
	auth_code: pre + 'captcha', //获取验证码
	send_channel: pre + 'season/getCapacity', //通过渠道获取信息
	discernInfo: pre + 'discern', //根据discern获取信息
	commit: pre + 'submit', //注册
	// check: pre + 'check',
	get_crm: pre + 'guestInfo', //获取crm用户信息
	isOver: pre + 'channel/findChannelById',
	check_whitelist: pre + '/check_whitelist',
	// 核销
	login: impower + 'ba/login',
	confirm: impower + 'ba/confirm',
	ba_check: impower + 'ba/check',
	//分享
	share: 'wechat-api/signatureEncoding?callback=https://campaign.chanel.com.cn/wechat-api/refreshToken&url=', //'https://campaign.chanel.com.cn/wechat-obtain/evidence/signature'
}

/**
 *
 * @param {city} data
 */
export function getSceneInfo(data) {
	return Api.post(interfaces.get_scene + `?sceneId=${data.sceneId}`)
}

/**
 *
 * @param {city} data
 */
export function findAll(data) {
	return Api.post(interfaces.find_all + `?sceneId=${data.sceneId}`)
}
/**
 *
 * @param {*} data
 */
export function isExist(data) {
	return Api.post(interfaces.is_exist + `?phone=${data.phone}&sceneId=${data.sceneId}`)
}
/**
 *
 * @param {*} data
 */
export function getCode(data) {
	return Api.post(interfaces.auth_code + `?phone=${data.phone}&sceneId=${data.sceneId}`)
}
/**
 *
 * @param {name, phone, code, date[, time]} data
 */
export function commit(data) {
	console.log(data)
	let { captcha } = JSON.parse(JSON.stringify(data))
	delete data.captcha
	console.log(captcha)
	return Api.post(interfaces.commit + `?captcha=${captcha}&sceneId=${data.sceneId}`, data)
}
/**
 *
 * @param {channel}
 */
export function channelInfo(data) {
	return Api.post(interfaces.send_channel, data)
}
/**
 *
 * @param {name, mobile, code, date} data
 */
export function getCrm(data) {
	return Api.post(interfaces.get_crm + `?code=${data.code}&sceneId=${data.sceneId}`)
}
export function checkDiscern(data) {
	return Api.post(interfaces.discernInfo + `?discern=${data.discern}&sceneId=${data.sceneId}`)
}
export function impowerLogin(data) {
	return Api.post(interfaces.login, data)
}
export function impowerConfirm(data) {
	return Api.post(interfaces.confirm, data)
}
export function impowerCheck(data) {
	return Api.post(interfaces.ba_check, data)
}
export function checkWhiteList(data) {
	return Api.post(interfaces.check_whitelist, data)
}
//share
export function wxshare(data) {
	return Api.get(interfaces.share + encodeURIComponent(data.requestUrl))
}
